import { defineComponent as s, createBlock as c, openBlock as r, unref as m, withCtx as i, renderSlot as l, normalizeProps as a, guardReactiveProps as n, createElementBlock as u, createCommentVNode as b } from "vue";
import { RevModalBase as f } from "@ds/components/ModalBase";
const k = {
  key: 0,
  class: "pt-24"
}, B = /* @__PURE__ */ s({
  name: "RevDialog",
  __name: "Dialog",
  props: {
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    backdropZIndex: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 }
  },
  emits: ["open", "close"],
  setup(e) {
    return (t, d) => (r(), c(m(f), {
      "backdrop-background-color": "hi",
      "backdrop-z-index": e.backdropZIndex,
      "background-color": e.backgroundColor,
      class: "rounded-t-lg md:rounded-b-lg md:bottom-auto md:left-1/2 md:top-1/2 md:w-640 md:-translate-x-1/2 md:-translate-y-1/2",
      "close-button-label": e.closeButtonLabel,
      defer: e.defer,
      "disable-close-on-backdrop-click": e.disableCloseOnBackdropClick,
      "has-padding": e.hasPadding,
      name: e.name,
      title: e.title,
      to: e.to,
      onClose: d[0] || (d[0] = (o) => t.$emit("close", o)),
      onOpen: d[1] || (d[1] = (o) => t.$emit("open"))
    }, {
      body: i(({ close: o }) => [
        l(t.$slots, "body", a(n({ close: o }))),
        t.$slots.footer ? (r(), u("div", k, [
          l(t.$slots, "footer", a(n({ close: o })))
        ])) : b("", !0)
      ]),
      trigger: i(({ open: o }) => [
        l(t.$slots, "trigger", a(n({ open: o })))
      ]),
      _: 3
    }, 8, ["backdrop-z-index", "background-color", "close-button-label", "defer", "disable-close-on-backdrop-click", "has-padding", "name", "title", "to"]));
  }
});
export {
  B as default
};
